import { LoaderCircle } from 'lucide-react';

import { useEmail } from '@/components/providers/EmailProvider/EmailProvider';

import MultipleParties from './MultipleParties/MultipleParties';
import SearchParty from './SearchParty';
import SelectedParty from './SelectedParty/SelectedParty';

export default function PartySection() {
  const { party } = useEmail();

  return (
    <div
      className="overflow-hidden border-b p-2"
      data-onboarding-id="party-section"
    >
      {party.status === 'Loading' && (
        <div className="flex h-32 items-center justify-center">
          <LoaderCircle className="text-primary-500 h-6 w-6 animate-spin" />
        </div>
      )}

      {party.status === 'NoResults' && <SearchParty />}

      {party.status === 'MultipleFound' && <MultipleParties />}

      {party.status === 'Selected' && <SelectedParty />}
    </div>
  );
}
